import React, { Component, createRef } from "react";
import moment from "moment/moment";
// // Editable
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import { Card, Col, Container, Row } from "reactstrap";

import { Link } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import {
  getDataEntryStock,
  getUserByRoleId,
  getDataEntryDashboard,
 
  assignGraderToFillerInWardsRepeats,
  updateAssignGraderToFillerInWards,
  baseUrl,
  getExpressInwardApi,
} from "api";
import { withTranslation } from "react-i18next";
import RaisedButton from "components/Common/RaisedButton";
import OutwardFormModal from "../Common/OutwardFormModal";
class DataEntryExpressDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validation: "",
      editRowIndex: -1,
      inwardStockList: [],
      rejectStockList: [],
      outwardStockList: [],
      pendingStockList: [],
      repeatStockList: [],
      graderList: [],
      repeatRejectStockList: [],
      dashboardInfo: "",
      outwardModalOpen: false,
      outwardModalRow: null,
      deliveryBoyList: [],
    };
    this.openOutwardModal = this.openOutwardModal.bind(this);
    this.closeOutwardModal = this.closeOutwardModal.bind(this);
  }
  async componentDidMount() {
    try {
      const data = await getExpressInwardApi({
        page: null,
        limit: null,
      });
      console.log('data',data.data?.expressInwards);
      
      const inwardStockList = await getExpressInwardApi({
        page: 1,
        limit: 5,
        factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      });
      const rejectStockList = await getDataEntryStock({
        page: null,
        limit: null,
        factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
        graderStatus: "R",
      });
      const dashboard = await getDataEntryDashboard();
      const repeatStock = await assignGraderToFillerInWardsRepeats({
        page: 1,
        limit: 5,
        factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
        dataEntryStatus: "P",
      });
      const repeatRejectStock = await assignGraderToFillerInWardsRepeats({
        page: 1,
        limit: 5,
        factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
        dataEntryStatus: "R",
      });
      this.setState({
        pendingStockList:
          data.data?.expressInwards?.length == 0
            ? [
                {
                  id: "0",
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                      partyCode: "0",
                    },
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                },
              ]
            : data.data?.expressInwards,
        inwardStockList:
          inwardStockList.data?.expressInwards?.length == 0
            ? [
                {
                  id: "0",
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                      partyCode: "0",
                    },
                  },
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                },
              ]
            : inwardStockList.data?.expressInwards,
        rejectStockList:
          rejectStockList.data?.expressInwards?.length == 0
            ? [
                {
                  id: "0",
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                      partyCode: "0",
                    },
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                },
              ]
              : rejectStockList.data?.expressInwards,
        dashboardInfo: dashboard.data,
        repeatStockList:
          repeatStock.data.assignGraderToFillerInWards == 0
            ? [
                {
                  id: "0",
                  stockDataEntryInWard: {
                    srNo: 0,
                    pieces: 0,
                  },
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                      partyCode: "0",
                    },
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                },
              ]
            : repeatStock.data.assignGraderToFillerInWards,
        repeatRejectStockList:
          repeatRejectStock.data.assignGraderToFillerInWards == 0
            ? [
                {
                  id: "0",
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                      partyCode: "0",
                    },
                  },
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  stockDataEntryInWard: {
                    srNo: 0,
                    pieces: 0,
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                },
              ]
            : repeatRejectStock.data.assignGraderToFillerInWards,
      });
      // Fetch delivery boys for modal use
      // const deliveryBoy = await getUserByRoleId({
      //   factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      //   roleId: "ROLE0000006",
      // });
      // this.setState({
      //   deliveryBoyList: deliveryBoy.data.users,
      // });
    } catch (err) {
      console.log(err);
    }
  }

  async accept(row) {
    const data = await updateAssignGraderToFillerInWards({
      id: row.id,
      dataEntryStatus: "A",
    });
    if (data.success == true) {
      const repeatStock = await assignGraderToFillerInWardsRepeats({
        page: 1,
        limit: 5,
        dataEntryStatus: "P",
      });
      this.setState({
        repeatStockList: repeatStock.data.assignGraderToFillerInWards,
      });
    }
  }

  async reject(row) {
    const data = await updateAssignGraderToFillerInWards({
      id: row.id,
      dataEntryStatus: "R",
    });
    if (data.success == true) {
      const repeatRejectStock = await assignGraderToFillerInWardsRepeats({
        page: 1,
        limit: 5,
        dataEntryStatus: "R",
      });
      this.setState({
        repeatRejectStockList:
          repeatRejectStock.data.assignGraderToFillerInWards,
      });
    }
  }

  openOutwardModal(row) {
    this.setState({ outwardModalOpen: true, outwardModalRow: row });
  }
  closeOutwardModal() {
    this.setState({ outwardModalOpen: false, outwardModalRow: null });
  }

  render() {
    this.expressColumn = [
      {
        dataField: "id",
        text: `${this.props.t("Sr.No.")}`,
        sort: true,
        hidden: true,
      },
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.jangadId;
        },
      },
      {
        dataField: "partyName",
        text: `${this.props.t("Party Name")}`,
        formatter: (cell, row) => {
          return row.party?.name;
        },
      },
      {
        dataField: "category",
        text: `${this.props.t("Category")}`,
        formatter: (cell, row) => {
          return row.categoryId;
        },
      },
      {
        dataField: "unitName",
        text: `${this.props.t("Unit Name")}`,
        sort: true,
        formatter(cell, row) {
          return row?.noOfPieces;
        },
      },
      {
        dataField: "totalPieces",
        text: `${this.props.t("Total No Pieces")}`,
        formatter(cell, row) {
          return row?.totalWeight;
        },
      },

      {
        dataField: "totalWeight",
        text: `${this.props.t("Total Weight")}`,
        formatter(cell, row) {
          return row.totalWeight;
        },
      },
      {
        dataField: "outwardPieces",
        text: `${this.props.t("Outward Pieces/ Weight")}`,
        formatter(cell, row) {
          return `${row.deliveredPieces} / ${row.deliveredWeight} Kg`;
        },
      },
      {
        dataField: "deliveryBoyName",
        text: `${this.props.t("Delivery Boy Name")}`,
        formatter(cell, row) {
          return row.deliveryBoy?.name;
        },
      },
      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        formatter(cell, row) {
          return row.cycle;
        },
      },
      {
        dataField: "salesRemark",
        text: `${this.props.t("Sales Remark")}`,
        formatter(cell, row) {
          return row.salesRemark;
        },
      },
      {
        dataField: "endDate",
        text: `${this.props.t("Entry Date")}`,
        formatter(cell, row) {
          return moment(row.createdAt).format("DD/MM/YYYY");
        },
        sort: true,
      },
      {
        dataField: "status",
        text: `${this.props.t("Status")}`,
        formatter(cell, row) {
          return row.dataEntryStatus;
        },
      },
      {
        dataField: "lastOutwardYet",
        text: `${this.props.t("Last Outward Yet")}`,
        formatter(cell, row) {
          return row.graderStatus;
        },
      },
      {
        dataField: "dataEntryRemark",
        text: `${this.props.t("Data Entry Remark")}`,
        formatter(cell, row) {
          return row.dataEntryRemark;
        },
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) =>
          row.totalWeight == 0 ? (
            ""
          ) : (
            <>
              {/* {row.graderStatus == "A" ? ( */}
               
              {/* ) : ( */}
                <div className="btn-group">
                  <button
                    className="py-2 px-2 border-0 rounded"
                    onClick={() => this.openOutwardModal(row)}
                    type="button"
                  >
                    Outward
                  </button>
                  <Link
                    to={{
                      pathname: "/data-entry-accept-express-inward",
                      query: {
                        isEdit: 3,
                        data: row,
                      },
                    }}
                  >
                    <button className="py-2 px-2 border-0 ms-2 rounded">
                      <img src="images/dashboard-images/view.svg" />
                    </button>
                  </Link>
                </div>
              {/* )} */}
            </>
          ),
      },
    ]
  

    this.columns3 = [
      {
        dataField: "id",
        text: `${this.props.t("Sr.No.")}`,
        sort: true,
        hidden: true,
      },
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.jangadId;
        },
      },
      {
        dataField: "partyName",
        text: `${this.props.t("Party Code")}`,
        formatter: (cell, row) => {
          return row.party?.name;
        },
      },
      {
        dataField: "deliveryName",
        text: `${this.props.t("Delivery Boy Name")}`,
        formatter: (cell, row) => {
          return row.deliveryBoyName;
        },
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        sort: true,
        formatter(cell, row) {
          return row?.noOfPieces;
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        formatter(cell, row) {
          return row?.totalWeight;
        },
      },

      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        formatter(cell, row) {
          return row?.cycle;
        },
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Inward Date")}`,
        formatter(cell, row) {
          return moment(row.createdAt).format("DD/MM/YYYY");
        },
        sort: true,
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) =>
          row.weight == 0 ? (
            ""
          ) : (
            <>
              <div className="btn-group">
                <Link
                  to={{
                    pathname: "/data-entry-add-stock-inward",
                    query: {
                      isEdit: 1,
                      data: row,
                    },
                  }}
                >
                  <button className="py-2 px-2 border-0 rounded">
                    <img src="images/dashboard-images/edit.svg" />
                  </button>
                </Link>
              </div>
            </>
          ),
      },
    ];


    const defaultForCycleSorted = [
      {
        dataField: "cycle",
        order: "asc",
      },
    ];

    document.title = "data-entry flow";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Row>
              <Breadcrumbs breadcrumbItem={this.props.t("Dashboard")} />
              <Col xxl={2} lg={3}>
                <div className="bg-light-purple main_hero_section py-3 px-2">
                  <Row>
                    <Col sm={8}>
                      <div className="pt-4">
                        <h3 className="text-black">
                          {this.props.t("Welcome Back")}
                        </h3>
                      </div>
                    </Col>
                    <Col sm={4}>
                      <img
                        src={
                          JSON.parse(localStorage.getItem("authUser")).photo ==
                          null
                            ? "images/dashboard-images/welcome.svg"
                            : `${baseUrl}/uploads/${
                                JSON.parse(localStorage.getItem("authUser"))
                                  .photo
                              }`
                        }
                        className="img-fluid mt-3"
                        alt="welcome image"
                      />
                    </Col>
                    <p className="text-secondary">
                      {JSON.parse(localStorage.getItem("authUser")).name}
                    </p>
                  </Row>
                </div>
                <div className="bg-white main_hero_section_sub py-3 px-2">
                  <h4 className="text-black">
                    {this.props.t("User Dashboard")}
                  </h4>
                  <Link to="/profile">
                    {" "}
                    <button className="main_hero_section_sub_btn mt-3">
                      View Profile{" "}
                      <i className="fa-solid fa-arrow-right-long"></i>
                    </button>
                  </Link>
                </div>
              </Col>
              <Col xxl={10} lg={9}>
                <Row>
                  <Col lg={3}>
                    <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Daily Inward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.dailyInwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyinward.svg"
                            className="img-fluid"
                            alt="daily inward image"
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="bg-white main_hero_section_sub py-4 mt-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Daily Outward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.dailyOutwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyoutward.svg"
                            className="img-fluid"
                            alt="daily outward image"
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Weekly Inward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.weeklyInwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyinward.svg"
                            className="img-fluid"
                            alt="daily inward image"
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="bg-white main_hero_section_sub py-4 mt-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Weekly Outward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.weeklyOutwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyoutward.svg"
                            className="img-fluid"
                            alt="daily outward image"
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Monthly Inward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.monthlyInwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyinward.svg"
                            className="img-fluid"
                            alt="daily inward image"
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="bg-white main_hero_section_sub py-4 mt-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Monthly Outward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.monthlyOutwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyoutward.svg"
                            className="img-fluid"
                            alt="daily outward image"
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Yearly Inward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.yearlyInwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyinward.svg"
                            className="img-fluid"
                            alt="daily inward image"
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="bg-white main_hero_section_sub py-4 mt-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Yearly Outward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.yearlyOutwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyoutward.svg"
                            className="img-fluid"
                            alt="daily outward image"
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>

            <div className="row px-3 pt-4">
              <div>
                <h2 className="fw-bold pb-3 text-black">
                  {this.props.t("Pending List")}
                </h2>
              </div>
              <Card className="mt-4">
                <div className="table-responsive">
                  <BootstrapTable
                    keyField="id"
                    headerClasses="fs-5"
                    bordered={false}
                    striped={false}
                    data={this.state.pendingStockList}
                    columns={this.columns3}
                  />
                </div>
              </Card>
            </div>

            
            <div className="row px-3 pt-4">
              <div>
                <h2 className="fw-bold pb-3 text-black">
                  {this.props.t("EXPRESS INWARD")}
                </h2>
              </div>
              <Card className="mt-4">
                <div className="table-responsive">
                  <BootstrapTable
                    keyField="id"
                    headerClasses="fs-5"
                    bordered={false}
                    striped={false}
                    data={this.state.inwardStockList}
                    columns={this.expressColumn}
                  />
                </div>
              </Card>
            </div>
           
          </Container>
        </div>
        <OutwardFormModal
          isOpen={this.state.outwardModalOpen}
          toggle={this.closeOutwardModal}
          deliveryBoyList={this.state.deliveryBoyList}
          t={this.props.t}
          onSubmit={values => {
            console.log("Outward submit from dashboard", values, this.state.outwardModalRow);
            this.closeOutwardModal();
          }}
          initialValues={{
            piecesToDeliver: "",
            totalWeight: "",
            remark: "",
            deliveryBoy: "",
          }}
        />
      </React.Fragment>
    );
  }
}
export default withTranslation()(DataEntryExpressDashboard);
